var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4628_7193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2182 8.95151C15.6149 8.57183 16.2582 8.57183 16.6549 8.95151L19.7022 11.8679L19.7046 11.8702C19.801 11.963 19.8737 12.0697 19.923 12.1835C19.9723 12.2973 19.9996 12.422 20 12.5527L20 12.5556L20 12.5586C19.9996 12.6893 19.9723 12.814 19.923 12.9278C19.8737 13.0416 19.801 13.1483 19.7046 13.241L19.7025 13.2431L16.6549 16.1598C16.2582 16.5394 15.6149 16.5394 15.2182 16.1598C14.8215 15.7801 14.8215 15.1645 15.2182 14.7848L16.5316 13.5279H11.8731C11.312 13.5279 10.8572 13.0926 10.8572 12.5556C10.8572 12.0187 11.312 11.5834 11.8731 11.5834H16.5316L15.2182 10.3264C14.8215 9.94676 14.8215 9.33118 15.2182 8.95151Z",
    fill: "#A0AABB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V6C20 6.55228 19.5523 7 19 7C18.4477 7 18 6.55228 18 6V5C18 4.44771 17.5523 4 17 4H7C6.44771 4 6 4.44771 6 5V19C6 19.5523 6.44771 20 7 20H17C17.5523 20 18 19.5523 18 19V18C18 17.4477 18.4477 17 19 17C19.5523 17 20 17.4477 20 18V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5Z",
    fill: "#A0AABB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4628_7193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.4947ef54628c6ce2e262ff18e9ae1199.svg";
export { ForwardRef as ReactComponent };